import { useState } from "react";
import { ReferenceInput, Button, required, SelectInput, useNotify, useRefresh } from "react-admin";
import { Box, Typography } from "@mui/material";
import ReportIcon from "@mui/icons-material/Report";

import FormModal from "server/components/Modals/FormModal";
import { candidateRequests } from "api/candidateApi";
import LanguageIcon from "@mui/icons-material/Language";
import { useNotifyError } from "utils/useNotifyError";
import dataProvider from "server/dataProvider";

const ChangeInstructionLanguages = ({ record }) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const notifyError = useNotifyError();

  const [possibleChange, setPossibleChange] = useState(null);

  const checkPossibleChange = async () => {
    try {
      const res = await dataProvider.customRequest(
        candidateRequests.getCandidacyInstructionLanguagesForUpdate(record?.id),
      );
      setPossibleChange(res.data.length > 1);
    } catch (err) {
      notifyError(err);
    }
  };

  const handleSubmit = async data => {
    await dataProvider.customRequest(
      candidateRequests.updateCandidacyInstructionLanguages(record.id),
      { newInstructionLanguageId: data.instructionLanguageId },
      "PUT",
    );
    refresh();
    notify("Успешно сменен Език на обучение", { type: "success" });
  };

  return (
    <FormModal
      triggerButton={
        <Button
          disabled={record?.hasApprovedRanking}
          startIcon={<LanguageIcon />}
          variant="contained"
          sx={{ width: "max-content", mt: 1 }}
          label="Смени език на обучение"
          size="medium"
        />
      }
      titleContent="Смени език на обучение"
      onOpen={checkPossibleChange}
      confirmEnabled={possibleChange}
      hideSaveButton={!possibleChange}
      onConfirm={handleSubmit}
    >
      {possibleChange ? (
        <ReferenceInput
          source="instructionLanguageId"
          reference={candidateRequests.getCandidacyInstructionLanguagesForUpdate(record.id)}
        >
          <SelectInput
            label="Език на обучение"
            validate={required()}
            optionText="nameBg"
          />
        </ReferenceInput>
      ) : (
        <Box>
          <Typography
            fontSize={16}
            fontWeight={"bold"}
            variant="h6"
            color={"error"}
            sx={{ display: "flex", gap: 2, width: "fit-content", margin: "1rem auto" }}
          >
            <ReportIcon
              color="error"
              fontSize="large"
              textAlign="center"
            />
            Невалидно действие
          </Typography>
          <Typography
            textAlign={"center"}
            margin={"2rem"}
            fontSize={14}
          >
            Няма наличен друг език на обучение
          </Typography>
        </Box>
      )}
    </FormModal>
  );
};

export default ChangeInstructionLanguages;
